module.exports = __webpack_public_path__ + "static/img/price-wrap_bg.4de40734.png";